export const salary = {
  shouldPayDateType: [{
    value: 1, label: '签单日期'
  }, {
    value: 2, label: '支付日期'
  }],
  havePayDateType: [{
    value: 3, label: '打款日期'
  }],
  businessType: [{
    value: 1, label: '财险'
  }, {
    value: 2, label: '寿险'
  }],
  deductionType: [{
    value: 1, label: '税前加款'
  }, {
    value: 2, label: '税前扣款'
  }, {
    value: 3, label: '税后扣款'
  }]
}

export default {
  salary
}



// WEBPACK FOOTER //
// ./src/data/salary.js